define([
	"dojo/_base/declare",
	"csi/action/EditController",
	"csi/locale",
	"csi/xml",
	"SiteAdmin/BusinessObject",
	"SiteAdmin/Locale"
], function(declare,EditController,locale,xml,BusinessObject,Locale) {

	return declare(EditController, {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set value for season to the parent season and make it read only
			var typeClass = BusinessObject.getRootType(this.getNode());
			view.addDefaultValue("LocaleName", Locale.getTypeName(typeClass));
			view.addDefaultValue("LocalePlural", Locale.getTypeResource(typeClass, locale.TYPE_PLURAL));
			view.addDefaultValue("LocaleTooltip", Locale.getTypeResource(typeClass, locale.TYPE_TOOLTIP));
			this.inherited(arguments);
		},

		toWriter: function() {
			var	typeClass = BusinessObject.getRootType(this.getNode());
			var	w = this.m_writer;
			var	fd = this.m_formData;
			var	b;

			var	writeField = function(name, id) {
				var	f = fd.getField(name);
				if (f && f.isUpdated()) {
					Locale.setResource(w, Locale.ATTR_TYPES, [typeClass, id], f.getValue(), null, true);
					b = true;
				}
			};

			this.inherited(arguments);

			writeField("LocaleName", locale.TYPE_NAME);
			writeField("LocalePlural", locale.TYPE_PLURAL);
			writeField("LocaleTooltip", locale.TYPE_TOOLTIP);

			if (b) {
				w.changeNode(this.m_urlNode).changeAttribute(BusinessObject.ATTR_MODIFIED, xml.ATTR_BOOLEAN, true);
			}
		},

		postProcessSuccess: function() {
			// summary: apply changes to localization resources from this form
			Locale.flushResources();
			this.inherited(arguments);
		}
	});
});